import { writable, readable, derived, get as take } from 'svelte/store';
import { PATH_COUNTRIES } from './config.js';
import get from 'lodash/get'
import head from 'lodash/head'
import includes from 'lodash/includes'
import isNumber from 'lodash/isNumber'
import keys from 'lodash/keys'
import last from 'lodash/last'
import without from 'lodash/without'
import map from 'lodash/map'
import trim from 'lodash/trim'
import csv from 'csvtojson';

function validateEmail (email) {
	// https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript
  const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

function getContactList (country) {
	const contact = get(country, 'contact', '').split(';')
	const contactDomain = get(country, 'contact-domain', '').split(';')
	const contactPrefix = get(country, 'contact-prefix', '').split(';')
	if (contact.length === contactDomain.length && contactDomain.length === contactPrefix.length) {
		const contacts = []
		for (let i = 0; i < contact.length; i++) {
			const c = trim(contact[i])
			const p = trim(contactPrefix[i])
			const d = trim(contactDomain[i])
			const mail = `${p}@${d}`
			if (c && d && p && validateEmail(mail)) {
				contacts.push([c, mail])
			} else {
				console.log(`Invalid mail: ${mail}`)
			}
		}
		return contacts
	} else {
		return []
	}
}

export const COUNTRIES = readable([], async (set) => {
	const res = await fetch(PATH_COUNTRIES);
  const string = await res.text()
  csv({ delimiter: ',' })
		.fromString(string)
		.then(json => {
			const datum = map(json, (country, i) => {
				return {
					id: i,
					code: get(country, 'code'),
					contacts: getContactList(country),
					label: get(country, 'country'),
					description: get(country, 'description'),
					link: get(country, 'link'),
					location: get(country, 'location'),
					status: get(country, 'status')
				}
			})
			set(datum)
		})
});

// Currently displayed in modal
export const CURRENT_COUNTRY = writable(false);

export const CURRENT_COUNTRY_DETAILS = derived([CURRENT_COUNTRY, COUNTRIES], ([$currentCountry, $countries]) => {
	return get($countries, $currentCountry, false)
});

// Map or table view? (true = map, false = table)
export const VIEW = writable(true);

// List of active/hoverd countries
export const COUNTRY = writable([]);
